export const PercentageIcon = ({ className = "w-6 h-6" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    fill="none"
    viewBox="0 0 18 18"
  >
    <path
      strokeWidth="1.5"
      d="M6.33241 6.86574H7.39908M10.5991 11.1324H11.6657M11.6657 6.33241L6.33241 11.6657M8.25348 1.84174L7.04921 3.04388C6.85184 3.2416 6.58405 3.35286 6.30468 3.35321H4.40814C4.12864 3.35321 3.86059 3.46424 3.66295 3.66188C3.46531 3.85952 3.35428 4.12757 3.35428 4.40708V6.30361C3.35393 6.58298 3.24266 6.85078 3.04494 7.04814L1.84174 8.25454C1.64418 8.45217 1.5332 8.72017 1.5332 8.99961C1.5332 9.27905 1.64418 9.54705 1.84174 9.74468L3.04708 10.9489C3.14483 11.0467 3.22237 11.1628 3.27526 11.2906C3.32816 11.4183 3.35537 11.5552 3.35534 11.6935V13.59C3.35534 14.1724 3.82681 14.6439 4.40921 14.6439H6.30574C6.58521 14.6439 6.85294 14.7548 7.05028 14.9532L8.25561 16.1575C8.45324 16.355 8.72124 16.466 9.00068 16.466C9.28012 16.466 9.54812 16.355 9.74574 16.1575L10.95 14.9521C11.1476 14.7548 11.4153 14.6439 11.6945 14.6439H13.5911C13.8706 14.6439 14.1386 14.5328 14.3363 14.3352C14.5339 14.1376 14.6449 13.8695 14.6449 13.59V11.6935C14.6449 11.414 14.7559 11.1463 14.9543 10.9489L16.1585 9.74361C16.3561 9.54598 16.4671 9.27798 16.4671 8.99854C16.4671 8.7191 16.3561 8.45111 16.1585 8.25348L14.9532 7.04921C14.7559 6.85167 14.645 6.58389 14.6449 6.30468V4.40814C14.6449 4.12864 14.5339 3.86059 14.3363 3.66295C14.1386 3.46531 13.8706 3.35428 13.5911 3.35428H11.6945C11.4152 3.35393 11.1474 3.24266 10.95 3.04494L9.74361 1.84174C9.54598 1.64418 9.27798 1.5332 8.99854 1.5332C8.7191 1.5332 8.4511 1.64418 8.25348 1.84174V1.84174Z"
    />
  </svg>
);

export const CrossIcon = ({ className = "w-6 h-6" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    fill="none"
    viewBox="0 0 16 16"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.6"
      d="M12.665 3.333l-9.333 9.333M3.332 3.333l9.333 9.333"
    ></path>
  </svg>
);
